import type { MailListFilter } from '@embertime/shared'

export type { MailListFilter }
export type MailListCounts = Record<MailListFilter, number>

export interface MailFilterChip {
  id: MailListFilter
  label: string
  icon?: 'star' | 'paperclip'
  /** Show the folder count next to the label (mockup 1c: unread + attachment). */
  showCount: boolean
}

/** Chips above the mail list (#778), in mockup 1c order. The snooze chip
 * „Später" joins this list with #780. */
export const MAIL_FILTERS: readonly MailFilterChip[] = [
  { id: 'all', label: 'Alle', showCount: false },
  { id: 'unread', label: 'Ungelesen', showCount: true },
  { id: 'flagged', label: 'Stern', icon: 'star', showCount: false },
  { id: 'attachment', label: 'Anhang', icon: 'paperclip', showCount: true },
]

/** Exactly one chip is active; tapping the active one returns to „Alle". */
export function toggleMailFilter(current: MailListFilter, tapped: MailListFilter): MailListFilter {
  return tapped === current ? 'all' : tapped
}

/** Header count next to the folder title: „3 von 148" with a filter, else the
 * unread text. Without counts (still loading) it keeps the unread text. */
export function mailHeaderCount(
  filter: MailListFilter,
  counts: MailListCounts | undefined,
  unread: number,
): string {
  if (filter === 'all' || !counts) return `${unread} ungelesen`
  return `${counts[filter]} von ${counts.all}`
}

/** Hint line under the chips while a filter is active, else null. */
export function mailFilterHint(filter: MailListFilter, searchActive: boolean): string | null {
  if (filter === 'all') return null
  const label = MAIL_FILTERS.find((f) => f.id === filter)?.label ?? filter
  return `Filter: ${label} · ${searchActive ? 'in der Suche' : 'nur dieser Ordner'}`
}
